module.exports = __webpack_public_path__ + "static/media/cut_-_color_on_transparent__rgb-02.b357d53b.png";